import '|/app.styl';

// Scripts
import CardTip from './CardTip';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Run our utility scripts
        new CardTip();

    });

})(jQuery);